import RelationshipMetadata from "../../RelationshipMetadata";

class ProjectPlanPhaseProjectPlanPhaseApprovalRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "ProjectPlanPhaseProjectPlanPhaseApprovalRelationshipMetadata";
        this.parentEnterpriseComponent = "ProjectPlanPhase";
        this.childEnterpriseComponent = "ProjectPlanPhaseApproval";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "ProjectPlanPhaseUSID";
    }
}

export default ProjectPlanPhaseProjectPlanPhaseApprovalRelationshipMetadata;